import axios from "axios";
import tippy from "tippy.js";
import Choices from "choices.js";

export default class Global {

    constructor() {
        this.initLanguageSwitch();
        this.initTippy();
        this.initNumericInputs();
        this.initSearch();
        this.initNewsletter();
        this.initChoices();
    }

    initLanguageSwitch() {
        let languageWrapper = document.querySelector('header .language-wrapper');
        let language = document.querySelector('header .language-wrapper .language');
        let languageSelect = document.querySelector('header .language-wrapper .language-select');

        if (language) {
            language.addEventListener('click', e => {
                languageSelect.classList.toggle('active');
            });

            document.addEventListener('click', e => {
                let isClickInside = languageWrapper.contains(e.target);

                if (!isClickInside) {
                    languageSelect.classList.remove('active');
                }
            });
        }
    }

    initTippy() {
        tippy('[data-tippy-content]', {
            allowHTML: true
        });
    }

    initNumericInputs() {
        const inputs = document.querySelectorAll('input.numeric');
        inputs.forEach(input => {
            input.addEventListener('keydown', e => {
                let key = e.charCode || e.keyCode || 0;

                let result = (
                    key === 8 ||
                    key === 9 ||
                    key === 13 ||
                    key === 46 ||
                    key === 110 ||
                    key === 190 ||
                    (key >= 35 && key <= 40) ||
                    (key >= 48 && key <= 57) ||
                    (key >= 96 && key <= 105)
                );
                if (!result) {
                    e.preventDefault();
                }
            });
        });
    }

    initSearch() {
        const form = document.getElementById('searchForm');
        const input = form.querySelector('input');
        const results = document.getElementById('searchResults');
        const loader = document.createElement('i');
        loader.classList.add('loader', 'loader-alt', 'd-none');
        results.append(loader);
        let source;

        document.addEventListener('click', e => {
            let isClickInside = form.contains(e.target);

            if (!isClickInside) {
                results.innerText = '';
                results.classList.remove('show');
                input.value = '';
            }
        });

        form.addEventListener('submit', e => {
            e.preventDefault();
        });

        input.addEventListener('keyup', e => {
            if (timeout) {
                clearTimeout(timeout);
            }
            let timeout = window.setTimeout(e => {

                let value = input.value;
                if (input.value.length > 2) {
                    results.querySelectorAll('li').forEach(li => {
                        li.remove();
                    });
                    loader.classList.remove('d-none');
                    results.classList.add('show');

                    if (source) {
                        source.cancel();
                    }
                    const CancelToken = axios.CancelToken;
                    source = CancelToken.source();

                    axios({
                        method: 'post',
                        url: '/zoeken',
                        data: {
                            searchterm: value
                        },
                        cancelToken: source.token
                    })
                        .then(function (response) { // success

                            loader.classList.add('d-none');
                            let data = response.data;
                            if (data.length) {
                                data.forEach(product => {
                                    let li = document.createElement('li');
                                    let a = document.createElement('a');
                                    a.setAttribute('href', product.url);
                                    a.innerText = product.name

                                    li.append(a);
                                    results.append(li);
                                });
                            } else {
                                let li = document.createElement('li');
                                let a = document.createElement('a');
                                a.innerText = 'Geen resultaten';
                                li.append(a);
                                results.append(li);
                            }
                        })
                        .catch(function (error) { // error
                            console.log(error);
                        })
                        .then(function () { // always
                        });

                } else {
                    results.querySelectorAll('li').forEach(li => {
                        li.remove();
                    });
                    results.classList.remove('show');
                }
            }, 500);
        });
    }

    initNewsletter() {
        const form = document.getElementById('newsletterForm');
        const input = document.getElementById('newsletterEmail');
        const button = document.getElementById('newsletterButton');

        form.addEventListener('submit', e => {
            e.preventDefault();

            let message = document.querySelector('.newsletter-message');
            if (message) {
                message.remove();
            }

            let icon = button.querySelector('i');
            icon.classList.remove('icon-arrow-right');
            icon.classList.add('loader', 'loader-primary');

            axios({
                method: 'post',
                url: '/inschrijven-nieuwsbrief',
                data: {
                    email: input.value
                }
            })
                .then(response => { // success
                    if (response.data) {
                        let message = document.createElement('div');
                        message.classList.add('alert', 'alert-success', 'newsletter-message');
                        message.innerText = 'Bedankt voor je inschrijving';
                        form.prepend(message);
                    }
                })
                .catch(error => {
                    let message = document.createElement('div');
                    message.classList.add('alert', 'alert-danger', 'newsletter-message');
                    message.innerText = error.response.data.errors.email[0];
                    form.prepend(message);
                })
                .then(function () { // always
                    icon.classList.remove('loader', 'loader-primary')
                    icon.classList.add('icon-arrow-right');
                    input.value = '';
                });
        });
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }
}
